import Footer from "../footer/Footer";
import { Helmet } from "react-helmet";
import { Trans } from 'react-i18next'
import "./Pages.css";
const CurrentProjects = () => {
  return (
    <div>
      <div className="projects-current">
        <Helmet>
          <title>
            Esnad e.V | Current Projects | Laufende Projekte
          </title>
        </Helmet>
        <Trans i18nKey="Current-Projects-Content" components={{ p: <p/> , pre: <pre/>,h2: <h2/>, h4: <h4/>, div: <div/>, ul: <ul/>, li: <li/>, strong: <strong/>, h5: <h5/>}} />
      </div>
      <div>
        <Footer />
      </div>
    </div>
  );
};

export default CurrentProjects;
